export const EXPORT_TEMPLATE_IDS = [
  "export-ami",
  "export-bourasseau",
  "export-etri",
  "export-fabera-consultation",
  "export-fahrner-industries",
  "export-hexalean",
  "export-ms71",
  "export-nsn",
] as const;

export type ExportTemplateId = (typeof EXPORT_TEMPLATE_IDS)[number];

export const isExportTemplateId = (value: unknown): value is ExportTemplateId =>
  EXPORT_TEMPLATE_IDS.some((templateId) => templateId === value);
